import React, { Fragment } from 'react';
import * as Actions from 'providers/components/list/actions';

const ProvidersActions = ({ company, subcompany, permissions, provider, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.providers_clients.toggle'] && (
        <Actions.Toggle provider={provider} handleClick={handleToggle} />
      )}

      {permissions['acl.providers_clients.update'] && (
        <Actions.Edit
          company={company}
          subcompany={subcompany}
          provider={provider}
          handleClick={handleToggle}
        />
      )}
    </Fragment>
  );
};

export default ProvidersActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/list/ProvidersActions.js